export default {"src":"/_next/static/media/shed.f3e29809.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};